const init = () => {
  const entryButton = document.querySelector('.js-entryButton');
  const footerElm = document.getElementById('js-footer');

  if (!entryButton) return;
  
  window.addEventListener('scroll', () => {
    const footerRect = footerElm.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    if (footerRect.top < windowHeight) {
      entryButton.classList.add('is-fadeout');
    } else {
      entryButton.classList.remove('is-fadeout');
    }
  });
};

export {
  init,
};